export const CATEGORIES_DEMO = [
  { id: 'cat_01', name: 'Hoodies',     slug: 'hoodies',     productCount: 12, parentId: null, sortOrder: 1, isActive: true },
  { id: 'cat_02', name: 'Camisas',     slug: 'camisas',     productCount: 18, parentId: null, sortOrder: 2, isActive: true },
  { id: 'cat_03', name: 'Tracksuits',  slug: 'tracksuits',  productCount: 4,  parentId: null, sortOrder: 3, isActive: true },
  { id: 'cat_04', name: 'Accesorios',  slug: 'accesorios',  productCount: 7,  parentId: null, sortOrder: 4, isActive: true },
  { id: 'cat_05', name: 'Drop SS26',   slug: 'drop-ss26',   productCount: 9,  parentId: null, sortOrder: 5, isActive: true },
]
